export default function linkedInButtonStyles({
  backgroundColor = "text.primary",
  color = "background.paper",
  hoverBackgroundColor = backgroundColor,
} = {}) {
  return {
    backgroundColor,
    color,
    // Keep the foreground visible when the theme's text-button hover rule runs.
    "&:hover, &:active, &:focus": {
      backgroundColor: hoverBackgroundColor,
      color,
      opacity: 1,
    },
    "&.Mui-disabled": {
      backgroundColor,
      color,
      opacity: 1,
    },
  };
}
